"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logger = void 0;

const logger = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log(...args); // eslint-disable-line
  } // Add sentry, etc...

};

exports.logger = logger;